import theme from "../../../styles/theme";
const { colors } = theme;

export default (props) => {
	return `
        font-family: ${theme.font.regular}, "Helvetica Neue", Helvetica, Arial, sans-serif;
        ${props.bold ? `font-family: ${theme.font.bold};` : ``}
        ${props.semiBold ? `font-family: ${theme.font.semiBold};` : ``}
        color: ${props.color ? colors[props.color] || props.color : colors.black};
        ${props.textAlign ? `text-align: ${props.textAlign};` : ""}
        ${props.recoletaBold ? `font-family: ${theme.font.recoletaBold};` : ``}
        ${props.styles ? `${props.styles}` : ""};
        strong, b {
            font-family: "ProximaNova-Bold";
        }
        
        text-transform: ${props.uppercase ? "uppercase" : ""};
        margin-bottom: 0;
        p {
            margin-bottom: 0;
            font-family: ${theme.font.regular}, "Helvetica Neue", Helvetica, Arial, sans-serif;
            ${props.bold ? `font-family: ${theme.font.bold};` : ``}
            ${props.semiBold ? `font-family: ${theme.font.semiBold};` : ``}
            color: ${props.color ? colors[props.color] || props.color : colors.black};
            text-align: ${props.textAlign ? props.textAlign : "left"};
        }
        
    `;
};
